import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/Header';

import { QuestionnaireProvider } from './QuestionnaireContext'; 

export default function QuestionnaireLayout() {
  return (
    <QuestionnaireProvider>
      <div className="container-fluid px-4">
        <Header path="/app/customers/" />
        <div className="row justify-content-center">
          <div className="col-xs-12 col-md-10 col-lg-8">
            <Outlet />
          </div>
        </div>
      </div>
    </QuestionnaireProvider>
  );
}